module.exports = __webpack_public_path__ + "static/media/banner-photo1024@3x.5fa1c847.jpg";